import React from 'react';
import { useTranslation } from 'react-i18next';

import Header from '@/components/header';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import GenerateAudioWithDataset from '@/routes/(app)/(tasks)/components/generate-audio-with-dataset';
import GenerateAudioWithFile from '@/routes/(app)/(tasks)/components/generate-audio-with-file';

const GenerateAudioTab = {
  WITH_FILE: 'generate-audio-with-file',
  WITH_DATASET: 'generate-audio-with-dataset',
} as const;

const GenerateAudio = () => {
  const { t } = useTranslation();
  return (
    <div className='flex flex-col gap-6'>
      <div className='flex flex-col gap-2'>
        <Header
          title={t(`tasks.generateAudio.title`)}
          description={t(`tasks.generateAudio.description`)}
        />
      </div>
      <Tabs defaultValue={GenerateAudioTab.WITH_DATASET}>
        <TabsList>
          <TabsTrigger value={GenerateAudioTab.WITH_DATASET}>
            {t('tasks.generateAudio.withDataset.title')}
          </TabsTrigger>
          <TabsTrigger value={GenerateAudioTab.WITH_FILE}>
            {t('tasks.generateAudio.withFile.title')}
          </TabsTrigger>
        </TabsList>
        <TabsContent value={GenerateAudioTab.WITH_DATASET}>
          <GenerateAudioWithDataset />
        </TabsContent>
        <TabsContent value={GenerateAudioTab.WITH_FILE}>
          <GenerateAudioWithFile />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default GenerateAudio;
